import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    title = 'app';

    public notificationOptions = {
        timeOut: 3000,
        lastOnBottom: true,
        clickToClose: true,
        showProgressBar: false,
        animate: null
    };

    constructor() {
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/app.component.ts